import DataSource from "../DataSource";
import RecordSource from "../DataSource/RecordSource";
import Resource from "../Resource";
import Record from "../Resource/Record";

export default class UzivatelService {

  constructor(server){
    this.server = server;
  }

  list(){
    return this.server("listUzivatelia");
  }

  listWithPermission(perm){
    return this.list().then(r=> r.filter(u => u.permissions.indexOf(perm) >= 0));
  }

  save(item){
    return this.server("saveUzivatel", {uzivatel: item});
  }

  disable(uzivatelId){
    return this.server("disableUzivatel", {id: uzivatelId});
  }

  enable(uzivatelId){
    return this.server("enableUzivatel", {id: uzivatelId});
  }

  setPassword(uzivatelId, password){
    return this.server("Uzivatel.update", {id: uzivatelId, password: password}); 
  }

  setMyPassword(oldPassword, newPassword){
    return this.server("Uzivatel.setMyPassword", {oldPassword: oldPassword, newPassword:newPassword})
  }

  listRole(){
    return this.server("listRole");
  }

  listPermissions(){
    return this.server("listPermissions");
  }

  saveRole(role){
    return this.server("saveRole", {role: role});
  }

  removeRola(rolaId){
    return this.server("removeRola", {id: rolaId});
  }

  getUserRecordSource(config = {}){
    return new RecordSource(new Resource(this.server, "Uzivatel"), this.server, "Uzivatel.list", config);
  }

}


// WEBPACK FOOTER //
// ./src/services/UzivatelService.js